(() => {
  'use strict';
  if (window.customimaClarityInstalled) return;
  window.customimaClarityInstalled = true;
  let loaded = false;
  let reloading = false;

  function syncConsent() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || reloading) return;
    const analytics = privacy.analyticsProcessingAllowed() === true;
    if (!analytics && !loaded) return;
    window.clarity = window.clarity || function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };
    window.clarity('consentv2', {
      analytics_Storage: analytics ? 'granted' : 'denied',
      ad_Storage: analytics && privacy.marketingAllowed() && privacy.saleOfDataAllowed() ? 'granted' : 'denied',
    });
    if (!analytics) {
      // The persisted Shopify decision prevents the SDK loading in the next document.
      reloading = true;
      window.clarity('stop');
      window.location.reload();
      return;
    }
    if (loaded) return;
    loaded = true;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.clarity.ms/tag/qn3vi1f4dz';
    document.head.append(script);
  }

  document.addEventListener('visitorConsentCollected', syncConsent);
  if (window.Shopify?.customerPrivacy) syncConsent();
  else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      if (!error) syncConsent();
    });
  }
})();
